<template>
	<div>
		<h3>商户签约详情</h3>
		<div class="details">
			<ul :style="{width:dataList.product.generalBalance == 1 && ifFzjg != 4?'100%':'60%'}">
				<li>商品名称：{{dataList.product.name}}</li>
				<li>商户名称：{{jigouData.name}}</li>
<!-- 				<li>商品编号： SP00001</li>
				<li>商户编号：XXXXXXX22DD</li> -->
				<li>使用建议零售价：{{dataList.cp.priceMode == 1 ? '是':'否'}}</li>
				<!-- <li>江泰收入：<span class="yellow">¥{{dataList.cutAmount/100}} 元</span> </li> -->
				<li>销售价格：<span class="yellow">¥{{dataList.cp.price/100}} 元</span></li>
				<!-- <li>商户地址：{{jigouData.contact2}}</li> -->
			</ul>
			<div class="ewm" v-if="dataList.product.generalBalance != 1 || ifFzjg == 4">
				<ewm :index=1 :imagePath='imagePath' :channelId='channelId' :channelData='channelData' :id='this.$route.query.id' :subChannelId='subChannelId'></ewm>
			</div>
		</div>
		<div class="table">
			<el-table :data="dataList.clst" style="width: 100%" height='calc(100vh - 410px)'>
				<el-table-column prop="date" label="序号" align='center'>
					<template slot-scope="scope">
						<span>{{ scope.$index + 1}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="机构名称" align='center'></el-table-column>
				<el-table-column label="分成比例" align='center'>
					<template slot-scope="scope">
						<span class="yellow">{{ scope.row.cutType == 1? scope.row.amount+' %':scope.row.amount/100 + '元'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="分成方式" align='center'>
					<template slot-scope="scope">
						<span>{{ scope.row.cutType == 1? '比例':'数额'}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import { commodityDetail,getInfo,listchannelBySetter } from '@/axios/api.js'
	import ewm from './ewm'
	export default{
		data(){
			return{
				tableData:[],
				imagePath:require('../../assets/img/logo2.png'),
				jigouData:{},
				dataList:{
					product:{},
					cp:{},
				},
				channelId:JSON.parse(window.localStorage.getItem("token")).data.obj2.channelId,
				channelData:[],
				subChannelId:'',
				ifFzjg:JSON.parse(window.localStorage.getItem("token")).data.obj.category
			}
		},
		components:{
			ewm
		},			
		methods:{
			getData(){
				var id=this.$route.query.id;
				var data={
					id
				}
				commodityDetail(data)
				.then(res => {
					this.dataList=res.data.obj;
					if(this.dataList.cutLst == undefined || this.dataList.cutLst.length == 0) return
					this.dataList.clst.forEach(item => {
						var id=item.id
						if(this.dataList.cutLst.length == 0) return
						this.dataList.cutLst.forEach(item1 => {
							if(id == item1.channelId){
								item.amount=item1.amount;
								item.cutType=item1.cutType;
							}
						})
					})
				})
				.catch( err => {
					console.log(err)
				})
				getInfo()
				.then(res => {
          localStorage.setItem("category", res.data.obj.category);
					if(res.data.code == 0){
						this.jigouData=res.data.obj;
					}else{
						this.$message(res.deta.msg);
					}
				})
				.catch( err => {
					console.log(err)
				})				
			},
			getDataList() {
				//获取渠道
				var data = {
					start: 0,
					count: 1000
				}
				listchannelBySetter(data)
					.then(res => {
						if (res.data.code == 0) {
							this.channelData = res.data.obj;
							this.subChannelId = res.data.obj[1].id;
						}
					})
					.catch(err => {
						console.log(err)
					})

			},									
		},
		mounted() {
			this.getData();
			this.getDataList()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3{font-weight: normal;margin-bottom: 20px;margin-top: 20px;}
	.details{overflow: hidden;min-width: 900px;margin-left: 20px;}
	.details ul{float: left;width: 70%;overflow: hidden;}
	.details .ewm{float: left;width: 30%;}
	.details .ewm p{color: #666;}
	.details .ewm *{text-align: center;display: block;margin: 0 auto;}
	.details ul li{float: left;margin-bottom: 35px;width: 50%;color: #333;}
	.table{margin-top: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/commodity/shopDetails.vue